<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>标引任务</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <!--工具条 begin-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="期刊：" prop="journalName">
            <el-select v-model="journalId" filterable  placeholder="请选择期刊" @change="journalSelectChanged">
                <el-option
                v-for="item in journals"
                :key="item.journalId"
                :label="item.journalName"
                :value="item.journalId"
                ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
            <el-button size="mini" type="primary" @click="creatTask(null)">创建转换任务</el-button>
        </el-form-item>
    </el-form>
    </el-col> 
    <!--工具条 end-->

    <!-- 列表显示 begin-->
    <el-col :span="24" class="tablebar" style="padding-bottom: 0px;">
    <el-table :data="tasks" style="width: 100%;overflow: auto;" stripe highlight-current-row v-loading="tableLoading" class="tablebar">
      <!-- 第一行显示数据 -->
      <!-- <el-table-column
        width="50">
      </el-table-column> -->
      <el-table-column prop="name" label="任务名称" sortable align="center"></el-table-column>
      <el-table-column prop="type" label="任务类型" sortable align="center"></el-table-column>
      <el-table-column prop="flag" label="状态" sortable align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.flag === 1? 'success' : 'danger'"
            disable-transitions>{{scope.row.flag}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="描述" sortable align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.flag === 1? 'success' : 'danger'"
            disable-transitions>{{scope.row.status}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="finishTime" label="完成时间" sortable align="center"></el-table-column>
      <!-- 操作按钮 -->
      <el-table-column label="操作" width="200" align="center">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" :style="(scope.row.flag === 0) ? { display: '' } : { display: 'none' }" @click="transform(0, scope.row)">开始转换</el-button>
          <el-button :loading="scope.row.btnLoading" type="primary" size="mini" :style="(scope.row.flag !== 0 && scope.row.flag !== 3) ? { display: '' } : { display: 'none' }" @click="transform(1, scope.row)">重试</el-button>
        </template>
      </el-table-column>
      <el-table-column label="日志" width="140" align="center">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="showLogs(scope.row)">查看日志</el-button>
        </template>
      </el-table-column>
      <el-table-column label="下载" width="140" align="center">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" :style="(scope.row.flag === 1) ? { display: '' } : { display: 'none' }" @click="downLoadTransFile(scope.row)">下载标引、XML文件</el-button>
        </template>
      </el-table-column>
      <el-table-column label="PDF" width="140" align="center">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" :style="(scope.row.xml3dFile!=null ) ? { display: '' } : { display: 'none' }" @click="downLoadPDF(scope.row)">下载PDF</el-button>
        </template>
      </el-table-column>
      <el-table-column label="删除任务" width="100" align="center">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" @click="deleteTask(scope.row)">删除</el-button>
        </template>
      </el-table-column>
      <div slot="empty" class="empty">
        <el-empty description="暂无数据"></el-empty>
      </div>
    </el-table>
    </el-col>
    <!-- 列表显示 end-->
    <!--底部分页-->
    <el-col :span="24" class="foolbar">
        <!-- hide-on-single-page  -->
      <el-pagination 
        background 
        layout="total, sizes, prev, pager, next"
        @size-change="handleSizeChange" 
        @current-change="handleCurrentChange" 
        :page-size="pageSize"
        :page-sizes = pageSizes
        :total="total" 
        hide-on-single-page 
        style="float:right;">
      </el-pagination>
    </el-col>

    <!--新增对话框界面 begin-->
    <el-dialog title="转换任务创建" :visible.sync="addFormVisible" :close-on-click-modal="false" v-loading="createLoading" element-loading-text="创建中"
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" @close='closeDialog1'>
        <el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
            <!-- 创建form -->
            <el-form-item label="任务名称:" prop="taskName">
                <el-input v-model="addForm.taskName" placeholder="请在此输入任务名称" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="中文题目:" prop="titleZh">
                <el-input v-model="addForm.titleZh" placeholder="请在此输入中文题目"></el-input>
            </el-form-item>
            <el-form-item label="英文题目:" prop="titleEn">
                <el-input v-model="addForm.titleEn" placeholder="请在此输入英文题目"></el-input>
            </el-form-item>
            <el-form-item label="任务类型:" prop="type">
              <el-select v-model="addForm.type" filterable placeholder="请选择任务类型">
                  <el-option
                    v-for="item in typeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上传源文件:" prop="uploadFilePath">
              <template slot-scope="scope">
                  <el-upload
                    class="upload-demo"
                    ref="uploadDemo"
                    :action="packageUrl(flag,scope.row)"
                    :limit="1"
                    :file-list="fileList"
                    :on-success="uploadApkSuccess"
                    :before-upload="beforeUpload"
                    :auto-upload="false"
                    :on-change="changeFile"
                    :on-remove="removeFile"
                  >
                    <el-button size="small" type="success" @click="uploadClick()">点击上传</el-button>
                  </el-upload>
              </template>
            </el-form-item>
        </el-form>
        <!-- 创建form -->
        <div slot="footer" class="dialog-footer" align="center">
            <el-button @click.native="addFormVisible = false">取消</el-button>
            <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
    </el-dialog>
    <!-- 新增对话框界面 end -->
    <el-dialog class="log" title="处理日志" :visible.sync="processDialogVisible" width="80%">
      <template>
        <el-table
          :data="logList"
          height="600"
          border
          stripe>
          <el-table-column
            prop="id"
            label="序号"
            width="50">
          </el-table-column>
          <el-table-column
            label="描述">
            <template slot-scope="scope">
              <pre style="white-space: pre-wrap;">{{ scope.row.info }}</pre>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </el-dialog>
    <!-- 在此添加新的页面元素 -->
  </el-row>
</template>

<script>
import API_TYPESET_TASK from "../../api/api_autoTypeset_task";

export default {
  data() {
      var uploadFile = (rule, value, callback) => {
        if(value.length === 0){
          callback(new Error('请上传文件'));
        }else{
          callback()
        }
      };
    return {
      createLoading:false,
      addFormVisible: false, //新增界面是否显示
      addLoading: false, //新增界面加载状态
      addFormRules: {
          taskName: [
              { required: true, message: "请输入文章的DOI", trigger: "change" }
          ],
          type:[
              { required: true, message: "请选择期刊的issn", trigger: "change" }
          ],
          uploadFilePath:[
              { required: true, validator: uploadFile }
          ]
      },
      addForm: {
          taskName: "",
          type: "",
          uploadFilePath:"",
          titleZh:"",
          titleEn:"",
      },


      searchForm:{
        taskName:"",
        type:"",
        statusId:"",
      },
      
      statusList:[],

      typeList:[
          {
              value: '1',
              label: '标引+xml'
          }, 
          {  
              value: '2',
              label: '仅标引'
          },
          {
              value: '3',
              label: '仅转换XML'
          }
      ], 

      //列表显示相关数据
      task:{},
      tasks: [],
      fileList: [],
      //页码
      page: 1,
      //每页数量
      pageSize: 10,
      pageSizes: [10, 20, 50, 100],
      //总数
      total: 0,
      clientHeight: window.innerHeight - 258,
      //页面载入状态
      tableLoading: false,

      processDialogVisible:false,
      logList:[],

      //定时任务
      openStatue:false,
      interTimer : null,

      
      journals:[],
      journalId:"",
      //院刊
      //journalId:"41a27886a01c4eef9839d7096f389497"

      //BMPG
      //journalId:"682047d4073341cbafd437d5d0602ff3"
    };
  },
  methods: {
    // 弹框关闭定时器开启
    closeDialog1(){
      this.openStatue = false
    },
    //
    journalSelectChanged(value){
      this.journalId = value;
      this.findAllLogs();
    },


    //获取可查看的期刊权限
    getJournalList(){
      let params = {};
      API_TYPESET_TASK.getTypesetJournalList(params)
      .then(res=>{
        if(res && res.errorCode===0){
            this.journals = res.journalList;
            this.journalId = res.journalList[0].journalId;
            this.findAllLogs();
        }
      })
      .catch(e=>{
        this.$message({
          showClose:true,
          type:"error",
          message:"请求出现异常",
          duration:2000
        });
      });
    },

    //获取指定ID的结果
    findLogByPrimaryId(id){
      var that = this;
      let params = {
        id: id,
      };
      API_TYPESET_TASK.getAutoCollationLogById(params)
      .then(res=>{
        if(res && res.task){
          if(res.task.flag===1 || res.task.flag===2){
            //刷新
            that.findAllLogs();
          }
        }
      })
      .catch(e=>{
        this.$message({
          showClose:true,
          type:"error",
          message:"请求出现异常",
          duration:2000
        });
        //刷新
        that.findAllLogs();
      });
    },

    //获取所有结果
    findAllLogs(){
      this.tableLoading = true
      let params = {
        //默认院刊，后面可选
        journalId:this.journalId,
        page: this.page,
        pageSize: this.pageSize,
      };
      API_TYPESET_TASK.getAutoTypesetTasks(params)
      .then(res=>{
        if(res && res.tasks){
          this.tasks = Object.values(res.tasks);
          this.total = res.total;
        }
      })
      .catch(e=>{
        this.$message({
          showClose:true,
          type:"error",
          message:"请求出现异常",
          duration:2000
        });
      }).finally(()=>{
          this.tableLoading = false
        });
    },
    
    //下载PDF文件
    downLoadPDF:function(row){
      //window.location.href = row.xml3dFile;
      window.location.assign(row.xml3dFile);
    },

    //下载转换后的文件
    downLoadTransFile: function(row) {
      let params = {
        downloadUrl: row.outFilePath
      };
      API_TYPESET_TASK.downloadFile(params)
      .then(res => {
        if (navigator.userAgent.match(/MSIE\s([\d.]+)/) ||navigator.userAgent.indexOf("Trident") > -1) {
              window.navigator.msSaveBlob(res, row.fileName);
        } 
        else {
          const blob = new Blob([res]);
          const fileName = row.outFileName;
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }
      })
      .catch(e => {
        this.$message({
          showClose: true,
          type: "error",
          message: "请求出现异常",
          duration: 2000
        });
      });
    },

    deleteTask:function(row){
      let params = {
        id: row.id
      };
      API_TYPESET_TASK.deleteTask(params)
      .then(res => {
          if(res && res.errorCode===1){
              this.$message({
                showClose: true,
                type: "error",
                message: res.errorInfo,
                duration: 2000
              });
          }
          this.findAllLogs();
      })
      .catch(e=>{
          this.$message({
            showClose: true,
            type: "error",
            message: "deleteTask-请求出现异常",
            duration: 2000
          });
      });
    },

    transform: function(isRetry, row) {
      this.$set(row,'btnLoading',true)
      console.log("........transform:" + JSON.stringify(row));
      let that = this;
      let params = {
        taskId: row.id,
        isRetry:isRetry
      };
      //发送http请求
      API_TYPESET_TASK.startTranformation(params)
        .then(res => {
            if(res && res.errorCode!=0){
                this.$message({
                showClose: true,
                type: "error",
                message: res.errorInfo,
                duration: 2000
              });
            }
            else{
              //开启定时任务
              //this.TimerTask();
              //刷新一下状态
              that.findAllLogs();
            }
        })
        .catch(e => {
          this.$message({
            showClose: true,
            type: "error",
            message: "请求出现异常",
            duration: 2000
          });
        }).finally(()=>{
          this.$set(row,'btnLoading',false)
        });
    },

    packageUrl(flag,row)
    {
      return  "api/autoTypeset/fileUpload";
    },

    submitUpload() {
      this.$refs[`uploadDemo`].submit();
    },

    changeFile(file){
      if(file.status == 'ready'){
        const h = this.$createElement;
        this.$msgbox({
          title: '提示',
          message: h('p', null, [
            h('span', null, '请确定是否上传?'),
            //('i', { style: 'color: red' }, this.selectedLabel),
            //h('span',null,' 类型的文件?')
          ]),
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          this.submitUpload();
        }).catch(() => {
            this.$refs[`uploadDemo`].clearFiles();
            this.$message({
              type: 'info',
              message: '取消文件上传'
            });
        });
      }
    },
    removeFile(file){
      this.addForm.uploadFilePath = ''
      this.addForm.taskName = ''
      this.fileList= [];
      this.$refs[`addForm`].validateField('uploadFilePath')
    },

    uploadClick(){
    },
    beforeUpload(file){
      let types = ['application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
      const isJPG = types.includes(file.type);
      if(!isJPG){
        this.$message({
          showClose: true,
          type: "warning",
          message: '只能上传后缀为docx的文件',
          duration: 2000
        });
        return false
      }
    },
    uploadApkSuccess(response, fileList) {
      if(response.errorCode != 0)
      {
          this.$message({
          showClose: true,
          type: "info",
          message: response.errorInfo,
          duration: 2000
        });
        this.fileList= [];
        this.tableLoading = false;
        return;
      }
      else{
        //this.fileList= [];
        this.tableLoading = false;
        this.addForm.uploadFilePath = response.uploadFilePath;
        this.addForm.taskName = response.uploadFileName;
        // 去掉上传文件的校验
        this.$refs.addForm.validateField('uploadFilePath')
      }
    },

    showLogs: function(row){
        let params = {
          id: row.id
        };
        //发送http请求
        API_TYPESET_TASK.getTaskLog(params)
        .then(res => {
            if(res && res.code!=0){
                this.$message({
                showClose: true,
                type: "error",
                message: "获取任务日志失败",
                duration: 2000
              });
            }
            else{
              this.logList = res.logList;
              this.processDialogVisible = true;
            }
        })
        .catch(e => {
          this.$message({
            showClose: true,
            type: "error",
            message: "获取任务日志失败",
            duration: 2000
          });
        });
    },

    creatTask(){
        let that = this;
        that.addFormVisible = true;
        // 关闭定时器
        this.openStatue = true
    },

    //新增提交
    addSubmit: function() {
        let that = this;
        if (that.addLoading) return;
        that.$refs.addForm.validate(valid => {
            if (valid) {
            let params = {
                uploadFileName: that.addForm.taskName,
                uploadFilePath: that.addForm.uploadFilePath,
                type:that.addForm.type,
                journalId:that.journalId,
                titleZh:that.addForm.titleZh,
                titleEn:that.addForm.titleEn,
            };

            that.createLoading = true;

            console.log(
                ".........Task create by params:" + JSON.stringify(params)
            );

            //发送http请求
            API_TYPESET_TASK.insert(params)
                .then(res => {
                if (0 === res.errorCode) {
                    that.$message({
                    type: "success",
                    message: "创建成功!"
                    });

                    //创建成功后，刷新列表显示
                    this.findAllLogs();
                } else {
                    that.$message({
                    showClose: true,
                    message: res.errorInfo,
                    type: "error"
                    });
                }
                that.$refs["addForm"].resetFields(); //清空数据
                that.addFormVisible = false;
                that.createLoading = false;
                this.fileList= [];
                })
                .catch(e => {
                that.$message({
                    showClose: true,
                    type: "error",
                    message: "请求出现异常",
                    duration: 2000
                });
                that.$refs["addForm"].resetFields(); //清空数据
                that.addFormVisible = false;
                that.createLoading = false;
                this.fileList= [];
                });
            } else {
            that.$message({
                showClose: true,
                type: "warning",
                message: "请正确填写信息！",
                duration: 2000
            });
            }
        });
    },

    getRows: function(_page) {
      this.page = _page;
      this.findAllLogs();
    },

    handleSizeChange(val) {
        this.pageSize = val;
        this.findAllLogs();
      },

    //分页选择处理
    handleCurrentChange: function(val) {
      this.getRows(val);
    },

    findResult(){
      //点击查询按钮，分页初始化为1
      let _page = 1;
      //重新搜索时进行重置
      this.total = 0;
      //查询前清除查询列表信息
      this.logs = null;
      //进行分页查询
      this.getRows(_page);
    },

    //初始化表格高度
    initHeight: function() {
      this.clientHeight = (document.documentElement.clientHeight - 258) + 'px';
    },

    TimerTask:function(){
      if(this.openStatue){
        console.log('..........定时任务关闭');
        //关闭定时器
        clearInterval(this.interTimer);
      }
      else{
        console.log('..........定时任务启动.............');
        this.interTimer = setInterval(()=>{this.findAllLogs()},20000) //每10秒执行1次
      }
    },
    
  },
  mounted() {
    window.addEventListener('resize', this.initHeight);
    this.initHeight();
    this.getJournalList();
    
    this.TimerTask();
  },
  watch:{
    // 开启或关闭定时器
    openStatue(){
      this.TimerTask()
    }
  },
};
</script>

<style scoped>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #ab99bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/views/SysMng/AutoTypeset.vue